var watchlistSelector = {
	label: "Wählen Sie die Beobachtungsliste",
	validationErrors: {
		selectWatchlist: "Sie müssen eine Beobachtungsliste auswählen"
	}
};
var de = {
	watchlistSelector: watchlistSelector
};

export { de as default, watchlistSelector };
